import { render, staticRenderFns } from "./ColorCell.vue?vue&type=template&id=53351128"
import script from "./ColorCell.vue?vue&type=script&lang=js"
export * from "./ColorCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports